import http from '@/lib/http';

export default {
    queryOrgan(organCode) {
        return http({
            url: `/medicalCardService/queryOrgan/${organCode}`
        });
    },
    queryMedicalCardSettings(organId) {
        return http({
            url: `/medicalCardService/queryMedicalCardSettings/${organId}`
        });
    },
    registerHealthCard({ name, idNo, nation, phone, address, organId } = {}) {
        return http({
            url: `/medicalCardService/registerHealthCard`,
            data: {
                name, idNo, nation, phone, address, organId
            }
        });
    },
    editHealthCard({ nation, phone, address, id } = {}) {
        return http({
            url: `/medicalCardService/editHealthCard`,
            data: {
                nation, phone, address, id
            }
        });
    },
    queryMedicalCardList(organId) {
        return http({
            url: `/medicalCardService/queryMedicalCardList/${organId}`
        });
    },
    getMedicalCard(cardId) {
        return http({
            url: `/medicalCardService/getMedicalCard/${cardId}`
        });
    },
    setDefault(cardId, organId) {
        return http({
            url: `/medicalCardService/setDefault/${cardId}/${organId}`
        });
    },
    unBundling(cardId, organId) {
        return http({
            url: `/medicalCardService/unBundling/${cardId}/${organId}`
        });
    }
}
